import { render, staticRenderFns } from "./DicionarioDadosList.vue?vue&type=template&id=05b238f3"
import script from "./DicionarioDadosList.vue?vue&type=script&lang=js"
export * from "./DicionarioDadosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports